import React from "react";

import "./TransferDetails.css";
import {
    Typography,
    TextField,
    InputAdornment,
    Box,
    Button,
    // Autocomplete,
    Checkbox,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    MenuItem,
    FormControlLabel,
    FormGroup,
    InputLabel,
    Select,
  } from "@material-ui/core";
import { Link } from 'react-router-dom'
import Autocompete from '../JobRequisition/Autocompete'
  
import TransferHeader from './TransferHeader'
import TransferSidebar from './TransferSidebar'
const TransferDetails = () => {
   
  return (
    <>
  
     <TransferHeader/>
   
     <div class ="jobProcess">
    <TransferSidebar/>
    <div class="details">
    <h1>Details</h1>
    
     <div className="details-container">
     <h1>Administrative</h1>
     <div className='details-title'>Employee Type </div>
     <div className="details-ans"><FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Select one</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
        >
          <MenuItem value={10}>Select one</MenuItem>
          <MenuItem value={20}>Contigent Worker </MenuItem>
          <MenuItem value={30}>Regular</MenuItem>
         
        </Select>
      </FormControl></div></div>
     <div className="details-container">
     <div className='details-title'>Time Type <span className="mandatory">*</span></div>
     <div className="details-ans"><FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Select one</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          
        >
          <MenuItem value={10}>Select one</MenuItem>
          <MenuItem value={20}>Full Time</MenuItem>
          <MenuItem value={30}>Part Time</MenuItem>
         
        </Select>
      </FormControl> </div>

      <div className='location-title'>Location Weekly Hours<span className="mandatory">*</span></div>
     <div className="location-ans"> <input type ="number" className="detail-input"/></div>
     <div className='location-title'>Default Weekly Hours<span className="mandatory">*</span></div>
     <div className="location-ans"> <input type ="number"className="detail-input"/></div>
     <div className='location-title'>FTE<span className="mandatory">*</span></div>
     <div className="location-ans"> <input type ="number"className="detail-input"/></div>
     <div className='location-title'>Job Exempt<span className="mandatory">*</span></div>
     <div className="location-ans"> <input type ="text"className="detail-input"/></div>
     </div></div>
   
    </div> 
    <div className='next-bar'>
    <button className='back-btn'>Back</button>
    <button className='next-btn'>Next</button>
          
        </div>
    </>
  );
}
export default TransferDetails;